import { css, html } from 'react-strict-dom';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';

import Text from './Text';

type Props = {
  /** How much of the budget has gone, 0 to 1. */
  progress: number;
  label: string;
};

/**
 * A quantity being spent against what was bought.  Dates are not a quantity
 * and are drawn as a calendar instead.
 *
 * The bar stays blue however full it is: spending everything that was bought
 * is the arrangement working, not a fault to flag.
 */
export default function ProgressBar({ progress, label }: Props) {
  return (
    <html.div style={[Style.row, Style.alignCenter, styles.wrap]}>
      <html.span style={styles.track}>
        <html.span style={[styles.fill, styles.fillWidth(progress)]} />
      </html.span>
      <Text typeface="caption.medium" color="neutral60">
        {label}
      </Text>
    </html.div>
  );
}

const styles = css.create({
  wrap: {
    gap: 8,
  },
  track: {
    flexShrink: 0,
    height: 4,
    borderRadius: 999,
    backgroundColor: color.neutral15,
    overflow: 'hidden',
    width: {
      default: 120,
      '@media (max-width: 640px)': 80,
    },
  },
  fill: {
    display: 'block',
    height: 4,
    borderRadius: 999,
    backgroundColor: color.blue,
  },
  fillWidth: (progress: number) => ({
    width: `${progress * 100}%`,
  }),
});
